<template>
  <div>
    <TaskQueueAction v-if="!readOnly" />
    <button @click="getTaskQueues">Refresh Queues</button>
    <DataInput
      v-if="!readOnly"
      label="N tasks to ACK"
      width="8%"
      v-model.number="numberToAck"
    />
    <DataTable
      :rowKeys="['id']"
      :rows="taskQueues"
      :actions="
        !readOnly
          ? [
              {
                name: 'ackAllTasks',
                label: 'Ack ' + numberToAck + ' Tasks',
                function: actionAckAllTasks
              }
            ]
          : []
      "
      :columns="[
        { name: 'queueName', type: 'text' },
        { name: 'domain', type: 'text' },
        { name: 'size', type: 'text' },
        { name: 'uacked', type: 'text' },
        { name: 'workerId', type: 'text' },
        { name: 'lastPollTime', type: 'date' }
      ]"
    />
    <!-- Pagination -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import DataTable from '@/components/DataTable.vue'
import DataInput from '@/components/DataInput.vue'
import TaskQueueAction from '@/components/TaskQueueAction.vue'

export default {
  name: 'TaskQueueList',
  data() {
    return {
      numberToAck: 1
    }
  },
  computed: {
    ...mapGetters({
      taskQueues: 'taskQueuesByLastPollTime'
    }),
    ...mapState(['readOnly'])
  },
  methods: {
    ...mapActions(['getTaskQueues', 'ackAllTasks']),
    actionAckAllTasks(queue) {
      this.ackAllTasks([this.numberToAck, queue.queueName, queue.domain])
    }
  },
  created() {
    this.getTaskQueues()
  },
  components: {
    DataTable,
    DataInput,
    TaskQueueAction
  }
}
</script>
